import { createFileRoute, redirect } from '@tanstack/react-router'
import { fetchCapabilities } from '@/hooks/use-capabilities'
import { supabase } from '@/lib/supabase'

export const Route = createFileRoute('/_authed/admin/')({
  beforeLoad: async () => {
    // Forward to the first tab the caller can actually open. An unconditional
    // team-access forward bounced settings.manage-only admins straight back
    // out of the section (team-access guards on users.manage).
    const {
      data: { user },
    } = await supabase.auth.getUser()
    if (!user) throw redirect({ to: '/login' })

    const capabilities = await fetchCapabilities(user.id)
    if (capabilities.canManageUsers) {
      throw redirect({ to: '/admin/team-access' })
    }
    if (capabilities.canManageSettings) {
      throw redirect({ to: '/admin/modules' })
    }
    // Unreachable behind the parent guard; defensive for direct evaluation.
    throw redirect({ to: '/accounts' })
  },
  component: () => null,
})
